import React from 'react';
import PredictionInput from './pages/PredictionInput';
import PredictionDetail from './pages/PredictionDetail';
import Settlement from './pages/Settlement';
import History from './pages/History';
import PublicPrompt from './pages/PublicPrompt';
import SettlementQueue from './pages/SettlementQueue';
export { configure } from './api';
export const routes = [{
  path: '/macro-rotation',
  component: <History />
}, {
  path: '/macro-rotation/settlement',
  component: <SettlementQueue />
}, {
  path: '/macro-rotation/create',
  component: <PredictionInput />
}, {
  path: '/macro-rotation/prompts',
  component: <PublicPrompt />
}, {
  path: '/macro-rotation/predictions/:id',
  component: <PredictionDetail />
}, {
  path: '/macro-rotation/batches/:id/settlement',
  component: <Settlement />
}];
export const navigation = {
  id: 'macro-rotation',
  label: 'Macro Rotation',
  icon: 'ri-stock-line',
  link: '/macro-rotation'
};
export const publicNavigation = { label: 'Macro Rotation', link: '/macro-rotation', group: 'AI modes' };
export function getNavigation({ admin, paid }) {
  return { ...navigation, subItems: [
    {id:'macro-rotation-history',label:'History',link:'/macro-rotation',parentId:navigation.id},
    ...(admin ? [
      {id:'macro-rotation-input',label:'Prediction Input',link:'/macro-rotation/create',parentId:navigation.id},
      {id:'macro-rotation-settlement',label:'Settlement',link:'/macro-rotation/settlement',parentId:navigation.id},
    ] : []),
  ] };
}
